import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TitleBlock from "../TitleBlock";
import RoomImage from "../../assets/images/brand/super-delux-rooms.jpg";
import { Link } from "react-router-dom";
const Rooms = () => {
  const count = [1, 2, 3];
  return (
    <>
      <section className="roomsWrapper">
        <TitleBlock
          number="03"
          pretitle="explore"
          title="Room & Suites"
          desc="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
          aliquid nesciunt pariatur reprehenderit, possimus labore eligendi
          beatae facilis eum maiores."
        />

        <section>
          <Container>
            <Row className="gy-5">
              {count.map((m) => {
                return window.location.href.includes("room") ? (
                  <>
                    <Col md={6}>
                      <section className="roomCard">
                        <figure className="roomCard-image">
                          <img src={RoomImage} alt="" />
                        </figure>
                        <h2 className="roomCard-title">standard twin room</h2>

                        <section className="roomCard-attributes">
                          <span>
                            30m<sup>2</sup> .
                          </span>
                          <span>2 Beds .</span>
                          <span>2 Guests </span>
                        </section>

                        <section className="text-center pb-3">
                          <Link
                            to="/roomdescription"
                            className="bton bton--md bton--ghost"
                          >
                            Further Information
                          </Link>
                        </section>
                      </section>
                    </Col>
                  </>
                ) : (
                  <Col md={4}>
                    <section className="roomCard">
                      <figure className="roomCard-image">
                        <img src={RoomImage} alt="" />
                      </figure>
                      <h2 className="roomCard-title">standard twin room</h2>

                      <section className="roomCard-attributes">
                        <span>
                          30<sup>2</sup> .
                        </span>
                        <span>2 Beds .</span>
                        <span>2 Guests </span>
                      </section>

                      <section className="text-center pb-3">
                        <Link
                          to="/roomdescription"
                          className="bton bton--md bton--ghost"
                        >
                          Further Information
                        </Link>
                      </section>
                    </section>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section>
      </section>
    </>
  );
};

export default Rooms;
